import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { selectAuthProvider } from '../../providers/AuthProvider/slice/selectors';

export function HomePage() {
  const { loadUser } = useSelector(selectAuthProvider);
  const [lastOrganisationId] = useLocalStorage('lastOrganisationId', null);

  const organisation_id = useMemo(() => {
    const organisations = loadUser.data?.access_organisations || [];
    if (
      lastOrganisationId &&
      organisations.find(o => o.id === +lastOrganisationId)
    ) {
      return lastOrganisationId;
    }
    if (organisations.length > 0) {
      return organisations[0].id;
    }
    return null;
  }, [lastOrganisationId, loadUser]);

  if (organisation_id) {
    return <Navigate to={`/organisation/${organisation_id}`} />;
  }

  return <></>;
}
